module.exports = __webpack_public_path__ + "img/250460827_2025_4-3.34d7df50.png";